import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import Card from '../card'
import { useBreakpoint } from '../../../../hooks/breakpoint'

import VideIcon from '../../../../public/img/bantrab/icon-video.svg'
import Typography from '../../typography'
import { getTransmissions as getItems } from '../../../../api/bantrab'

import { TRANSMISSIONS_LIST_QUERY as ITEMS_LIST_QUERY } from '../../../../api/bantrab/queries'

const ITEMS_PER_PAGE = parseInt(process.env.NEXT_PUBLIC_BANTRAB_TRANSMISSIONS_PER_PAGE_ON_LISTING)

const Recorded = ({ title, text, webinars, ...attrs }) => {
  const breakpoint = useBreakpoint()

  // const hasWebinars = get(webinars, 'items.length', 0) > 0

  const [isLoading, setIsLoading] = useState(0)
  const [displayFetchButton, setDisplayFetchButton] = useState(true)

  const [innerWebinars, setInnerWebinars] = useState({ ...webinars })

  useEffect(
    () => {
      const totalItems = get(innerWebinars, 'meta.totalCount', 0)
      const fetchedItems = get(innerWebinars, 'items', []).length
      setDisplayFetchButton(fetchedItems < totalItems)
      setIsLoading(false)
    },
    [innerWebinars]
  )

  const fetchWebinars = async () => {
    setIsLoading(true)

    const offset = get(innerWebinars, 'items', []).length
    let fetchedWebinars = await getItems({
      ...ITEMS_LIST_QUERY,
      offset: offset,
      limit: ITEMS_PER_PAGE,
      transmission_state: 'closed'
    })
    fetchedWebinars = await fetchedWebinars.json()

    const updatedWebinars = { ...innerWebinars }
    updatedWebinars.meta = {
      ...updatedWebinars.meta,
      ...fetchedWebinars.meta
    }

    updatedWebinars.items = updatedWebinars.items.concat(fetchedWebinars.items)

    setInnerWebinars(updatedWebinars)
  }

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-8',
      'md:pt-20',
      'pb-10',
      'md:pb-20'
    ]
  )

  return <section
    {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4',
          'mb-10'
        ])
      }>
      <div
        className={
          classNames([
            'relative',
            'flex',
            'flex-col',
            'md:flex-row',
            '-mx-4'
          ])
        }>
        <div
          className={
            classNames([
              'px-4',
              'flex',
              'flex-col',
              'md:flex-row'
            ])
          }
          style={{
            flexBasis: breakpoint.lgAndUp ? '33.333333%' : (breakpoint.mdAndUp ? '50%' : '100%')
          }}>
          <VideIcon
            width={100}
            height={100}
            className={'flex-none block mx-auto mb-4 md:mb-0 md:mr-4 md:ml-0 '} />
          <Typography
            size={breakpoint.mdAndUp ? 'seven' : 'five'}
            weight={'black'}
            className={'text-center md:text-left'}>
            {title}
          </Typography>
        </div>
        <div
          className={
            classNames([
              'px-4',
              'py-4',
              'text-right'
            ])
          }
          style={{
            flexBasis: breakpoint.lgAndUp ? '66.666666%' : (breakpoint.mdAndUp ? '50%' : '100%')
          }}>
          <Typography
            size={breakpoint.mdAndUp ? 'three' : 'two'}
            weight={'regular'}
            className={'text-gray-400 text-center md:text-right'}>
            {text}
          </Typography>
        </div>
      </div>
    </div>

    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4',
          'mb-8'
        ])
      }>
      <div
        className={
          classNames([
            'relative',
            'flex',
            'flex-row',
            'flex-wrap',
            '-mx-4'
          ])
        }>
        {
          get(innerWebinars, 'items', []).map(
            (webinar, index) => {
              return <Card
                key={webinar.id}
                webinar={webinar} />
            }
          )
        }
      </div>
    </div>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      {
        displayFetchButton
          ? <div
            className={
              classNames([
                'w-full',
                'flex',
                'flex-row',
                'justify-center',
                'text-center',
                'border',
                'border-red-500',
                'text-red-500',
                'py-3',
                'mx-auto',
                'cursor-pointer',
                'hover:border-red-400',
                'hover:text-red-400',
                'active:border-red-600',
                'active:text-red-600'
              ])
            }
            style={{
              maxWidth: breakpoint.mdAndUp ? '240px' : '320px',
              borderRadius: '0 1.5rem 1.5rem 1.5rem'
            }}
            onClick={fetchWebinars}>
            Ver más webinars
          </div>
          : null
      }
    </div>
  </section>
}

Recorded.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  webinars: PropTypes.object
}

export default Recorded
